import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators'; // Add if not imported
import { IQuestionsWithAnswersModifiedResponse } from 'src/app/interfaces/questionManagement';
import { FlashCardManagementService } from 'src/app/Services/flashcard-management.service';
import { PreEvaluationQuestion, QuestionManagementService } from 'src/app/Services/question-management.service';
import { ConstantVars } from 'src/app/utils/constants/constants';
import { RelocateQuestionModalComponent } from '../relocate-question-modal/relocate-question-modal.component';
import { QuestionRelocateTreeModalComponent } from '../question-relocate-tree-modal/question-relocate-tree-modal.component';
import { ContentManagementNavigatorComponent } from '../../master/content-management-navigator/content-management-navigator.component';
import { ModalService } from 'src/app/Services/confirmation-modal/modalServie.service';

@Component({
  selector: 'app-question-list-modal',
  templateUrl: './question-list-modal.component.html',
  styleUrls: ['./question-list-modal.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class QuestionListModalComponent implements OnInit {
  @Input() SubjectId: number;
  @Input() QuestionId: string | null;
  @Input() ScreenName: string;
  @Input() filter: string = '';
  @Input() selectedSubject: any;
  @Output() openQuestionEdit = new EventEmitter<any>(); // Define EventEmitter
  private destroy$ = new Subject<void>();
  Questions: IQuestionsWithAnswersModifiedResponse[] = [];
  sortField: string = 'Display_Order';
  sortDirection: string = 'asc';
  filterText: string = '';
  path: string;
  relocateQuestions:boolean = false;
  selectedQuestions: IQuestionsWithAnswersModifiedResponse[] = [];
  selectedAction: 'relocate' | 'preEvaluation' | null = null;
  preSelectQuestions: boolean =false;
  selectedPreEvalQuestions: IQuestionsWithAnswersModifiedResponse[] = [];

  selectedCourse: null | {
  courseId: string
  examAgencyId: string
  courseName: string
  examYear: string
} = null;

  constructor(
    public activeModal: NgbActiveModal,
    public questionService: QuestionManagementService,
    public flashService: FlashCardManagementService,
    private sanitizer: DomSanitizer,
    private readonly toaster: ToastrService,
    private modalService: NgbModal,
    private modalServiceLocal: ModalService,
  ) {}

  ngOnInit(): void {
    const payloadGetquestions = {
      SubjectId: this.SubjectId,
      QuestionId: null,
      ScreenName: this.ScreenName,
      QuestionStatusTypeCode: this.filter,
    };
    const pathPayload = {
      SubjectId: this.SubjectId,
      Screenname: this.ScreenName,
    };

    forkJoin([
      this.questionService.getQuestionAndAnswers$(payloadGetquestions),
      this.questionService.getPath$(pathPayload),
      this.questionService.getPreviousQuestions(this.SubjectId)
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        ([question, path,previousQuestions]) => {
          this.Questions = question;
          this.path = path;
          console.log(previousQuestions);

        },
        (error) => {
          // Handle errors gracefully
          console.error('Error fetching questions:', error);
          this.toaster.error(
            'Failed to load questions. Please try again later.'
          );
        }
      );

    this.flashService.refreshFlag$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        console.log('afterEdit')
        this.sortField = 'Updated_Date';
        this.sortDirection = 'desc';
        this.getQuestionsAndAnswers();
      });
  }

  get FilteredSortedQuestions() {
    let filteredQuestions = this.Questions;

    // Filtering Logic
    if (this.filterText) {
      const filter = this.filterText.toLowerCase();
      filteredQuestions = filteredQuestions.filter(
        (question) =>
          question.Creation_Date?.toLowerCase().includes(filter) ||
          question.Updated_Date?.toLowerCase().includes(filter) ||
          question.Created_By?.toLowerCase().includes(filter) ||
          question.Updated_By?.toLowerCase().includes(filter) ||
          question.Question_Status_Type_Name?.toLowerCase().includes(filter) ||
          question.Question_Text?.toLowerCase().includes(filter) ||
          question.AllAnswers.some((answer: any) =>
            answer.Answer_Choice_Text?.toLowerCase().includes(filter)
          )
      );
    }

    // Sorting Logic
    filteredQuestions.sort((a, b) => {
      const fieldA =
        a[this.sortField as keyof IQuestionsWithAnswersModifiedResponse] ?? '';
      const fieldB =
        b[this.sortField as keyof IQuestionsWithAnswersModifiedResponse] ?? '';

      if (this.sortDirection === 'asc') {
        return fieldA < fieldB ? -1 : fieldA > fieldB ? 1 : 0;
      } else {
        return fieldA > fieldB ? -1 : fieldA < fieldB ? 1 : 0;
      }
    });

    return filteredQuestions;
  }
  onRelocateToggleChange(){
    if(!this.relocateQuestions){
      this.selectedQuestions = [];
      this.FilteredSortedQuestions.forEach((question)=>{
        question.selectedForRelocation = false;
      });
    }
  }

  RelocateQuestions(){
      // console.log(this.FilteredSortedQuestions.filter((question)=>question.selectedForRelocation));
      // const selectedQuestions = this.FilteredSortedQuestions.filter((question)=>question.selectedForRelocation);
      if(this.selectedQuestions.length > 0){
        this.openRelocateQuestionsModal(this.selectedQuestions);
      }else{
        this.toaster.error('No questions selected for relocation',"",{timeOut:ConstantVars.ToastErrorTimeout});
      }
  }
  openRelocateQuestionsModal(selectedQuestions:IQuestionsWithAnswersModifiedResponse[]){
    const modalRef = this.modalService.open(QuestionRelocateTreeModalComponent,
       { size: 'lg', centered: true,scrollable:true,  });
    modalRef.componentInstance.selectedQuestions = selectedQuestions;
    modalRef.componentInstance.selectedSubject = this.selectedSubject;
    modalRef.componentInstance.fromSubject = this.SubjectId
    modalRef.result.then((result) => {
      if(result === 'Saved'){
        this.activeModal.close('Saved');
      }
    });
  }

  getQuestionsAndAnswers() {
    const payloadGetquestions = {
      SubjectId: this.SubjectId,
      QuestionId: this.QuestionId,
      ScreenName: this.ScreenName,
      QuestionStatusTypeCode: this.filter,
    };
    this.questionService
      .getQuestionAndAnswers$(payloadGetquestions)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.Questions = res;
        if (this.Questions.length === 0) {
          this.activeModal.close('Refresh');
        }
      });
  }
  onRelocateCheckboxChange(event: { question: IQuestionsWithAnswersModifiedResponse, selected: boolean }) {
    console.log(event);
    if(event.selected){
      this.selectedQuestions.push(event.question);
    }else{
      this.selectedQuestions = this.selectedQuestions.filter((question:IQuestionsWithAnswersModifiedResponse)=>question.Question_ID !== event.question.Question_ID);
    }
    console.log(this.selectedQuestions);
  }

onPreEvalCheckboxChange(event: any) {
  const { question, selected } = event;

  if (selected) {
    this.selectedPreEvalQuestions.push(question);
  } else {
    this.selectedPreEvalQuestions = this.selectedPreEvalQuestions.filter(
      q => q.Question_ID !== question.Question_ID
    );
  }
}

  triggerParentFunction(question: IQuestionsWithAnswersModifiedResponse): void {
    // Emit data to the parent component
    const data = {
      Question_Id: question.Question_ID,
      Questions: this.Questions,
      Subject_Id: this.SubjectId,
    };
    this.openQuestionEdit.emit(data);
  }
  SanitizeHTML(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }


onActionChange() {

  this.relocateQuestions = false;
  this.preSelectQuestions = false;

  this.selectedQuestions = [];
  this.selectedPreEvalQuestions = [];

  this.Questions.forEach(q => {
    q.selectedForRelocation = false;
    q.selectedForPreEvaluation = false;
  });

  if (this.selectedAction === 'relocate') {
    this.relocateQuestions = true;
  }

  if (this.selectedAction === 'preEvaluation') {
    this.preSelectQuestions = true;
  }
}



OpenCourseSelection() {
  const modalRef = this.modalService.open(
    ContentManagementNavigatorComponent,
    { size: 'md', backdrop: 'static', centered: true }
  );

  modalRef.componentInstance.route = '';
  modalRef.componentInstance.param = 'QUESTION_PRE_EVALUATION_COURSE_SELECTION';

  modalRef.result
    .then((result) => {
      console.log('Modal closed with:', result);
      this.selectedCourse = result;
      this.getPreSelectedQuestions();

    })
    .catch((reason) => {
      console.log('Modal dismissed:', reason);
    });
}


getPreSelectedQuestions() {
  this.questionService.getPreEvaluationQuestions(
    Number(this.selectedCourse?.courseId) || 0,
    this.SubjectId
  ).subscribe({
    next: (res) => {

      // 1️⃣ Reset all pre-eval selections first
      this.selectedPreEvalQuestions = [];
      this.Questions.forEach(q => q.selectedForPreEvaluation = false);

      // 2️⃣ Build a lookup map for fast matching
      const preEvalMap = new Map(
        res.map(q => [q.Question_ID, q.Selected_Ind])
      );

      // 3️⃣ Sync API result → UI questions
      this.Questions.forEach(question => {
        if (preEvalMap.get(question.Question_ID) === 'Y') {
          question.selectedForPreEvaluation = true;
          this.selectedPreEvalQuestions.push(question);
        }
      });

      console.log('Pre-eval selected questions:', this.selectedPreEvalQuestions);
    },
    error: (err) => {
      console.error(err);
    },
  });
}





  onCross() {
    this.activeModal.close(false);
  }
  onPreEvalCancel() {
  // Reset only pre-evaluation state
  this.selectedPreEvalQuestions = [];
  this.selectedCourse = null;

  this.Questions.forEach(q => {
    q.selectedForPreEvaluation = false;
  });
}

async onPreEvalSave() {
  if (!this.selectedCourse) {
    this.toaster.error('Please select a course first');
    return;
  }
   const confirmMessage =
    `Are you sure you want to pre-evaluate questions for:\n\n` +
    `Course: ${this.selectedCourse.courseName}\n` +
    `Exam Year: ${this.selectedCourse.examYear}?`;

      const result = await this.modalServiceLocal.open(
      'Confirmation',
      confirmMessage
    );
      if (result) {
      this.savePreEvaluation();

      }

}


savePreEvaluation() {

  const payload: {
    LoggedInUser: string;
    CourseID: number;
    SubjectID: number;
    UDTCoursePreEvaluationQuestion: {
      QuestionID: string;
      SelectedIND: 'Y' | 'N';
    }[];
  } = {
    LoggedInUser: this.questionService.session.getUser(),
    CourseID: Number(this.selectedCourse!.courseId),
    SubjectID: this.SubjectId,
    UDTCoursePreEvaluationQuestion: this.Questions.map(q => ({
      QuestionID: q.Question_ID,
      SelectedIND: q.selectedForPreEvaluation ? 'Y' : 'N'
    }))
  };

  this.questionService
    .saveCoursePreEvaluationQuestions(payload)
    .subscribe({
      next: () => {
        this.toaster.success(
          `Pre-evaluation saved for ${this.selectedCourse?.courseName} (${this.selectedCourse?.examYear})`
        );
        this.activeModal.close('Saved');
      },
      error: (err) => {
        console.error(err);
        this.toaster.error(
          'Failed to save pre-evaluation questions',
          '',
          { timeOut: ConstantVars.ToastErrorTimeout }
        );
      }
    });
}


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
